import { render, staticRenderFns } from "./legalllm.vue?vue&type=template&id=d3f93374&scoped=true&lang=pug"
import script from "./legalllm.vue?vue&type=script&lang=ts"
export * from "./legalllm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f93374",
  null
  
)

export default component.exports